<ui-card *ngIf="vm$ | async as vm" [testHook]="testHooks.Card">
	<div card-header class="flex w-full flex-1 items-center justify-between">
		<div class="whitespace-nowrap flex items-center">
			{{ vm.name }}
			<app-icon
				class="mx-2"
				*ngIf="labelToolTip"
				[icon]="labelIcon"
				[classes]="labelIconClasses"
				[matTooltip]="labelToolTip"
			></app-icon>
		</div>
		<app-button
			*ngIf="vm.state === DisplayState.CARD"
			(click)="edit()"
			[icon]="ICON.EDIT"
			label="Edit Address"
			btn="tertiary"
			[testHook]="testHooks.EditAddressButton"
		>
		</app-button>
	</div>

	<ng-container [ngSwitch]="vm.state" card-content>
		<ui-address
			*ngSwitchCase="DisplayState.CARD"
			[address]="vm.address"
			class="w-3/4"
			[testHook]="testHooks.Address"
		></ui-address>

		<div *ngSwitchCase="DisplayState.EDIT">
			<app-address-form
				[address]="vm.address"
				[showCareOf]="vm.showCareOf"
				[displayCountryTop]="vm.displayCountryTop"
				[enableCountrySelect]="vm.enableCountrySelect"
				(onAddressUpdate)="onAddressUpdated($event)"
				(onAddressSearchUpdate)="onAddressSearchUpdated($event)"
				[testHook]="testHooks.AddressForm"
			>
			</app-address-form>
		</div>
	</ng-container>
</ui-card>
